@if (control) {
  <mat-form-field [disabled]="disabled" floatLabel="always" [class.is-disabled]="disabled">
    <mat-label [translate]="labelTranslateKey"></mat-label>

    <span matTextPrefix class="url-prefix-block">
      {{ appConfig.frontendUrl }}
    </span>

    <input
      matInput
      [formControl]="control"
      minlength="3"
      maxlength="20"
      placeholder="{{ placeholderTranslateKey | translate }}"
    />

    @if (!!control.hasError('required')) {
      <mat-error translate="FORMS.ERROR.FIELD_REQUIRED"></mat-error>
    }
    @if (!!control.hasError('invalidCharacters')) {
      <mat-error translate="FORMS.ERROR.INVALID_CHARACTERS"></mat-error>
    }
    @if (control.hasError('minlength') && !control.hasError('invalidCharacters')) {
      <mat-error>
        {{ 'FORMS.ERROR.MIN_LENGTH' | translate: { requiredLength: control.getError('minlength').requiredLength } }}
      </mat-error>
    }
  </mat-form-field>
}
